export const habaCommon = {
  pageHero: {
    sideTitle: 'Auf dieser Seite',
  },
  habaSearch: {
    placeholder: 'Suche',
    showMore: 'Mehr anzeigen',
    home: 'Start',
    searchSuggestions: 'Vorschläge',
    brandSuggestions: 'Marken',
    categorySuggestions: 'Kategorien',
    productSuggestions: 'Produkte',
    noSuggestions: 'Keine Ergebnisse.',
    noProductSuggestions: 'Für Ihre Suche gibt es keine Produktübereinstimmungen.',
    viewAll: 'Alle anzeigen',
    contentPages: 'Magazin',
    servicesAndBenefits: 'Services & Vorteile',
    faq: 'Häufig gestellte Fragen',
    more: 'Mehr',
    searchHistory: 'Dein Suchverlauf',
    clearHistory: 'Löschen',
    filterAndSort: 'Filtern & Sortieren',
    filters: {
      age: 'Alter',
      color: 'Farbe',
      brand: 'Marke',
      motives: 'Motiv',
      more: 'Mehr',
      price: 'Preis',
      collections: 'Kollektion',
      campaignTags: 'Kampagne',
      genders: 'Geschlecht',
      size: 'Größe',
      sizeSub: {
        appareal: 'Kleidergrößen',
        belts: 'Gürtelgrößen',
        brassieres: 'BH-Größen',
        caps: 'Mützengrößen',
        gloves: 'Handschuhgrößen',
        shoes: 'Schuhgrößen',
        specials: 'Sondergrößen',
      },
      ageGroups: 'Altersgruppe',
      ageRange: 'Alter',
      productFunctions: 'Funktion',
      productFeatures: 'Eigenschaft',
      materials: 'Material',
      sort: 'Sortieren',
      sortSub: {
        mostPopular: 'Beliebteste',
        new: 'Neuheiten',
        priceAsc: 'Niedrigster Preis',
        priceDesc: 'Höchster Preis',
        rating: 'Beste Bewertung',
        sale: 'Verkauf',
      },
      sortBy: 'Sortieren nach',
      categories: 'Weitere Kategorien',
      reviews: 'Bewertung',
      show: 'Anzeigen',
      filter: 'Filtern',
      resetAll: 'Alle zurücksetzen',
      showMore: '+ Mehr anzeigen',
      showLess: '- Weniger anzeigen',
      labels: {
        Babys: 'Baby (0 - 18 Monate)',
        Minis: 'Minis (1,5 - 5 Jahre)',
        Kids: 'Kids (5 - 7 Jahre)',
        Juniors: 'Juniors (ab 8 Jahre)',
        'keine Angabe': 'keine Angabe',
        Junge: 'Junge',
        Mädchen: 'Mädchen',
        unisex: 'Unisex',
        Adults: 'Erwachsene',
        männlich: 'männlich',
        weiblich: 'weiblich',
        0: 'bis 1 Jahr',
        1: 'ab 1 Jahr',
        2: 'ab 2 Jahre',
        3: 'ab 3 Jahre',
        4: 'ab 4 Jahre',
        5: 'ab 5 Jahre',
        6: 'ab 6 Jahre',
        7: 'ab 7 Jahre',
        8: 'ab 8 Jahre',
        9: 'ab 9 Jahre',
        10: 'ab 10 Jahre',
        11: 'ab 11 Jahre',
        12: 'ab 12 Jahre',
      },
      salesFilter: 'Nur Sonderangebote',
      specialPrice: 'Sonderangebote',
      personalization: 'Ja',
    },
    noResults: {
      showAllProducts: 'Mehr anzeigen',
      suggestions: 'Suchen Sie danach?',
      title: 'Hmmm...',
      messageFirstPart: 'Wir konnten keine Ergebnisse für <b>„{{ query }}“</b> finden.',
      messageSecondPart:
        'Überprüfen Sie Ihre Suche noch einmal auf Tipp- oder Rechtschreibfehler- oder versuchen Sie es mit einem anderen Suchbegriff.',
    },
    recommendations: {
      similarProducts: 'Ähnliche Produkte',
      matchingProducts: 'Passende Produkte',
    },
  },
  habaNavigation: {
    showAll: 'Alles anzeigen',
    more: 'Mehr',
    back: 'zurück',
    allProducts: 'Alle Produkte',
    topLinks: {
      contact: 'Kontakt',
    },
    showAllProducts: 'Alle Produkte anzeigen',
    shoppingCategories: 'Einkaufskategorien',
    mainEditorialCategories: 'Tipps und Inspiration',
    metaNavigationCategories: 'Service & Kontakt',
    showMore: 'Weitere Kategorien & Produkte',
    chooseLand: 'Wähle dein Land',
  },
  habaHttpHandlers: {
    notFound: '404 Seite nicht gefunden',
    notAvailable: 'Seite nicht erreichbar',
    code: {
      alreadyRedeemed:
        'Der von Dir angegebene Code wurde bereits eingelöst und kann nicht noch einmal verwendet werden.',
      maxApplied: 'Es können maximal 3 Gutscheine mit einer Bestellung eingelöst werden.',
      expired: 'Der von dir angegebene Code ist bereits abgelaufen.',
      unknownException: 'Der angegebene Code ist nicht gültig.',
      giftcardDisabled:
        '<strong>Es tut uns leid!</strong><br /> Unser Unternehmen befindet sich zur Zeit im Insolvenzverfahren in Eigenverwaltung. <br /><strong>Wenn der Gutschein vor dem 12.09.2023 erworben wurde, ist das Guthaben Teil des Verfahrens und kann leider momentan nicht eingelöst werden.</strong> <br />Ab voraussichtlich am 01.12.2023 kannst du deine Forderung in der Insolvenztabelle anmelden und geltend machen.',
      invalidCodeProvided:
        'Dieser Code ist nicht gültig. Bei weiteren Fragen wende dich an unser Kundenservice Team.',
      giftcardCommunicationError:
        'Die Einlösung des Code ist aus technischen Gründen vorübergehend nicht möglich. Bitte versuche es später nochmal oder kontaktiere unser Kundenservice-Team.',
      giftcardErrorS4NotAvailable:
        'Leider können Vorteilscodes derzeit aus technischen Gründen nicht eingelöst werden. Bitte wenden Sie sich an unseren Kundenservice.',
      giftcardRedemptionNotAllowed: 'Gutscheine können mit der Zahlungsart nicht eingelöst werden',
      giftcardInvalidBusinessModel: 'Der Code kann in diesem Webshop nicht eingelöst werden.',
      giftcardInvalidBrand: 'Die Gutscheinnummer kann in diesem Webshop nicht eingelöst werden.',
      giftcardInvalidCurrency: 'Die Gutscheinnummer ist für diese Währung nicht zugelassen.',
      giftcardAmount: 'Der Gutschein wurde bereits eingelöst.',
      giftcardInvalid: 'Dein Gutschein ist leider abgelaufen.',
      purchaseGiftcards:
        'Dieses Zahlungsmittel kann nicht für den Kauf von Wertgutscheinen verwendet werden',
      nothingLeftToPay: 'Der Betrag wurde bereits vollständig beglichen.',
      maximumQuantityReached: 'Angeforderte Mengen nicht mehr verfügbar. Mengen geändert.',
      maximumQuantityReachedProductPage: 'Maximal verfügbare Menge erreicht',
      noEffectOnCart:
        'Leider erreicht der Warenwert deiner Bestellung nicht den Mindestbestellwert. Bitte erhöhe deinen Bestellwert und gebe den Vorteilscode erneut ein.',
      noEffectOnCartWithoutCat:
        'Der Vorteilscode ist nur gültig in Verbindung mit dem Kauf von Produkten aus der Kategorie {{additionalMessage}} oder überprüfe die Höhe des Bestellwerts.',
      noEffectOnCartWithoutPerso:
        'Der Vorteilscode ist nur gültig, wenn deine Bestellung einen Personalisierten Artikel enthält. Falls der Warenwert deiner Bestellung nicht den Mindestbestellwert erreicht hat, dann erhöhe bitte deinen Bestellwert und gebe den Vorteilscode erneut ein.',
    },
    registration: {
      successHaba:
        '<strong>Dein HABA Konto ist jetzt aktiv.</strong> Bitte melde dich mit deinen Zugangsdaten an.',
      successHabaMobile:
        '<strong>Dein HABA Konto ist jetzt aktiv.</strong> <br /> Bitte melde dich mit deinen Zugangsdaten an.',
      tokenExpired: 'Token abgelaufen',
      invalidToken: 'Ungültiges Token',
      customerNotFound: 'Kunde nicht gefunden',
      userAlreadyExists: 'Upps, es ist ein Fehler aufgetreten. Bitte überprüfe deine Eingabe.',
      userAlreadyExistsEnterOrResetPass:
        'Zu dieser E-Mail-Adresse existiert bereits ein Kundenkonto bei HABA. Melde dich <a href="{{loginUrl}}">hier</a> an oder klicke auf <a href="{{forgotPassUrl}}">Passwort vergessen</a> falls du deine Anmelde-Daten vergessen hast',
      genericError:
        'Das hat leider nicht funktioniert. Bitte prüfe, ob du die richtige E-Mail-Adresse und das richtige Passwort verwendest.',
    },
    featureNotAvailable:
      'Diese Funktion steht aus technischen Gründen derzeit nicht zur Verfügung. Bitte wenden Sie sich an unseren Kundenservice.',
  },
  habaAuthentication: {
    success: 'Authentifizierung erfolgreich',
  },
  habaFooter: {
    contact: {
      retour: {
        headline: 'Retouren- & Widerrufsformular',
        description: 'Sie möchten eine Bestellung widerrufen oder Artikel retournieren?',
        button: 'Bestellung widerrufen',
      },
    },
    info: {
      heading: 'Kundenservice',
      schedule: 'Montag - Freitag 08-18 Uhr',
      telephone: '0800 - 9564956',
      email: 'service@wehfritz.com',
      contactForm: 'Kontaktformular',
    },
    shop: {
      catalog: {
        headline: 'Unser Katalog',
        text1: 'Katalog kostenlos anfordern',
        text2: 'Online blåttern',
      },
      payment: {
        headline: 'Unsere Zahlungsarten',
      },
      secureShopping: {
        headline: 'Sicheres Einkaufen',
        text1: 'Sichere Zahlung mit SSL-Verschlüsselung',
      },
      newsletter: {
        headline: 'Newsletter',
        text1: 'Zur Anmeldung',
        text2: 'Über alle Angebote, Neuheiten & Basteltipps informiert bleiben',
      },
    },
    serviceLinksHeader: 'Services & Vorteile',
    paymentMethodsHeader: 'Zahlungsarten & sicheres Einkaufen',
    helpfulLinksHeader: 'Hilfreiche Links',
    copyright:
      '© {{year}} - Die Habermaass GmbH & Co. KG mit ihren Marken ist Teil der Habermaass Firmenfamilie',
    links: {
      service: {
        heading: 'Service',
        link1: 'Beratung vor Ort',
        link2: 'Kontakt',
        link3: 'FAQ',
        link4: 'Leasing',
        link5: 'Retour',
        link6: 'Zertifikate',
      },
      about: {
        heading: 'Über uns',
        link1: 'Veranstaltungen',
        link2: 'Unternehmen',
        link3: 'Jobs',
      },
    },
    meta: {
      link1: 'Kontakt',
      link2: 'Presse',
      link3: 'Widerrufsbelehrung',
      link4: 'Widerrufsformular',
      link5: 'Entsorgungshinweis',
      link6: 'Impressum',
      link7: 'AGB',
      link8: 'Datenschutz',
      link9: 'Cookie-Einstellungen',
    },
    locale: {
      footerTitle: 'Länder- & Sprachauswahl',
      modalTitle: 'Wähle dein Land',
      country: 'Land wählen',
      language: 'Sprache',
      message: 'Deine Warenkorb wird geleert, wenn du dein Land wechselst.',
      submit: 'AUSWAHL BESTÄTIGEN',
    },
  },
  habaDelivery: {
    packageOnTheWay: 'Dein Paket ist auf dem Weg zu dir! Hier kannst du die Sendung verfolgen:',
  },
  footerNewsletter: {
    headline: 'Einfach zum Newsletter anmelden und dauerhaft profitieren.',
    email: {
      label: 'E-mail Adresse',
      error: 'Keine gültige E-Mail Adresse',
    },
    privacy: {
      label: 'Ich akzeptiere die <a>Datenschutzerklärungen</a>.',
      error: 'Bitte akzeptiere die Datenschutzerklärungen.',
    },
    submit: 'Zum newsletter anmelden',
    submitError: 'Sorry, das hat leider nicht funktioniert.',
  },
  habaExternalMessages: {
    'payment.error.default':
      'Während der Kontaktaufnahme zum Zahlungsanbieter ist ein Problem aufgetreten. Warte einige Minuten und versuche es erneut oder wähle eine andere Zahlungsmethode. Wenn das Problem weiterhin auftritt, wende dich an unser Kundenservicecenter.',
  },
  countdownBanner: {
    label: 'Noch:',
    days: 'Tage',
    day: 'Tag',
    hours: 'Std',
    minutes: 'Min',
    seconds: 'Sek',
    daysShort: 'D',
    hoursShort: 'H',
    minutesShort: 'M',
    secondsShort: 'S',
  },
};
